const SERVICE = 'user-service'

const login = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/login')

const logout = async (api, body) => {
  await api
    .setMethod()
    .get()
    .setService(SERVICE)
    .setAuthorizationToken(body.token)
    .process('/logout')
}

const logoutUser = async api => {
  await api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process('/logout')
}

const loginPhone = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/phone-number')

const register = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/register')

const me = async api => api.setMethod().get().setService(SERVICE).process('/me')

const loginOtp = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/otp-login')

const loginGoogle = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/google-login')

const loginApple = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/apple-login')

const forgetPassword = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/forgot-password')

const changePassword = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/change-password')

const postUser = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/user')

const importUser = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/import')

const checkEmail = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body)
  .process('/email')

const corporateVerify = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/corporate-verify')

const corporateActivate = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/corporate-activate')

const validatePhoneNumber = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/validate-phone-number')

const getProfile = async (api, params = {}) => api.setMethod().get().setService(SERVICE).process('/profile', params)

const putProfile = async (api, body) => api.setMethod().put().setBody(body).setService(SERVICE)
  .process('/profile')

const postDocDigitalInfoApi = async (api, body) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process('/doctor/digital')

module.exports = {
  login,
  register,
  me,
  loginOtp,
  loginGoogle,
  postUser,
  importUser,
  forgetPassword,
  changePassword,
  logout,
  loginPhone,
  checkEmail,
  corporateVerify,
  corporateActivate,
  validatePhoneNumber,
  getProfile,
  putProfile,
  loginApple,
  postDocDigitalInfoApi,
  logoutUser,
}
